// extracted by mini-css-extract-plugin
export var dropdownButton = "_3m-0";
export var fullWidthDropdownButton = "_3m-1";
export var icon = "_3m-3";
export var iconPlaceholder = "_3m-2";
export var menuItemRow = "_3m-5";
export var shortcutContainer = "_3m-4";